import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from "react-pro-sidebar";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import "../Sidebar/Navigation.css";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import {
  SystemModulesEnum,
  SystemUsersEnum,
} from "../../constants/SystemUsers";
import {
  PermissionService,
  PermissionEnum,
} from "../../constants/permissionService";
import { Typography } from "@mui/material";
const Navigation = (props) => {
  const auth = useAuth();
  const history = useHistory();
  const { pathname } = useLocation();
  const { collapseSidebar } = useProSidebar();
  const [nav, setNav] = useState([]);
  const [icon, setIcon] = useState(true);
  const [profileId, setProfileId] = useState();
  const [userRoleId, setUserRoleId] = useState();
  const [showSubMenu, setShowSubMenu] = useState(false);

  useEffect(() => {
    sideBarMenuData();
  }, [pathname]);

  useEffect(() => {
    collapseSidebar();
  }, [collapseSidebar]);
  const sideBarMenuData = async () => {
    const roleId = auth.getRole();
    setUserRoleId(roleId);
    const user = auth.getCurrentUser();
    const modules = auth.getModules();
    const visibleModules = Array.isArray(modules)
      ? modules.filter(
          (moduleItem) =>
            moduleItem?.name === "Dashboard" ||
            (Array.isArray(moduleItem?.features)
              ? moduleItem.features.some(
                  (feature) => feature?.featureName === PermissionEnum.LIST,
                )
              : false),
        )
      : [];
    let userProfileId = 0;
    switch (roleId) {
      case 5:
        userProfileId = user?.distributorUserId || user?.userId || 0;
        break;
      case 6:
        userProfileId = user?.enterpriseGroupId || user?.userId || 0;
        break;
      case 3:
      case 4:
      default:
        userProfileId = user?.userId || 0;
        break;
    }
    setProfileId(userProfileId);
    setNav(visibleModules);
  };

  const renderSubMenu = (item) => {
    const targetUrl = item?.url || "#";
    return (
      <Tooltip
        key={item.url || item.moduleId || item.name}
        title={item.title}
        placement="right"
      >
        <span>
          <MenuItem
            active={item?.url ? pathname.startsWith(item.url) : false}
            suffix={item.name}
            component={<Link to={targetUrl} />}
            onClick={() => {
              setShowSubMenu(false);
            }}
          ></MenuItem>
        </span>
      </Tooltip>
    );
  };

  const getLinkUrl = (res) => {
    const permissions = PermissionService(res.moduleId);
    const isDistributor = userRoleId === SystemUsersEnum.DISTRIBUTOR_INTERNAL;
    const isEnterprise = userRoleId === SystemUsersEnum.ENTERPRISE_INTERNAL;

    if (
      (!permissions.includes(PermissionEnum.LIST) &&
        res.name !== "Dashboard") ||
      (isDistributor && res.name === SystemModulesEnum.DISTRIBUTORS) ||
      (isEnterprise && res.name === SystemModulesEnum.ENTERPRISE_GROUPS)
    ) {
      return res.profileUrl ? `${res.profileUrl}${profileId}` : res.url || "#";
    }

    return res.url || "#";
  };

  return (
    <div className="my-sidebar">
      <Sidebar>
        <button
          type="button"
          className={icon ? "menu-collapsed-btn" : "menu-expanded-btn"}
          onClick={() => {
            collapseSidebar();
            setIcon(!icon);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              collapseSidebar();
              setIcon(!icon);
            }
          }}
          aria-label={icon ? "Expand menu" : "Collapse menu"}
          style={{
            cursor: "pointer",
            border: "none",
            padding: 0,
            margin: 0,
          }}
        >
          {icon ? <ChevronRightRoundedIcon /> : <ChevronLeftRoundedIcon />}
        </button>
        <Menu>
          <div className="main-menu-div">
            <div className="sidebar-main">
              <div
                className={icon ? "menu-logo-div" : "menu-logo-div-expanded"}
              >
                <button
                  type="button"
                  onClick={() => {
                    history.push("/dashboard");
                  }}
                  onKeyDown={(e) => {
                    /*istanbul ignore next */
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      history.push("/dashboard");
                    }
                  }}
                  aria-label="Go to dashboard"
                  style={{
                    all: "unset",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    className="menu-logo"
                    src="/images/menu-logo.png"
                    alt="menu-logo"
                  />
                </button>
              </div>

              {nav?.map((res) => {
                const uniqueSubMenuList = [
                  ...new Map(
                    res.childMenu.map((item) => [item["url"], item]),
                  ).values(),
                ];
                return res?.childMenu?.length ? (
                  <Tooltip
                    key={res.moduleId}
                    title={res.title}
                    placement="right"
                  >
                    <span>
                      <SubMenu
                        active={
                          uniqueSubMenuList.some((x) =>
                            pathname.startsWith(`${x.url}`),
                          )
                            ? "ps-menu-label active"
                            : ""
                        }
                        suffix={res.name}
                        icon={
                          <img
                            className={res.cssClass}
                            alt={res.name}
                            src={`/images/${res.menuImage}`}
                          />
                        }
                        onClick={() => {
                          setShowSubMenu(true);
                        }}
                      >
                        {uniqueSubMenuList.map((item) => {
                          return (!icon || showSubMenu) && renderSubMenu(item);
                        })}
                      </SubMenu>
                    </span>
                  </Tooltip>
                ) : (
                  <Tooltip
                    key={res.moduleId}
                    title={res.toolTip}
                    placement="right"
                  >
                    <span>
                      <MenuItem
                        className="my-menu"
                        data-testid={`menu-item-${res.moduleId}`}
                        component={<Link to={getLinkUrl(res)} />}
                        suffix={res.name}
                        active={
                          pathname.startsWith(`${res.url}`)
                            ? "ps-menu-label active"
                            : ""
                        }
                      >
                        <img src={"/images/" + res.menuImage} alt="menu-img" />
                      </MenuItem>
                    </span>
                  </Tooltip>
                );
              })}
            </div>
          </div>

          <div>
            <Tooltip title="FAQ's" placement="right">
              <span>
                <MenuItem component={<Link to="#" />} suffix="FAQ's">
                  <img src="/images/faqs.png" alt="faq-img" />
                </MenuItem>
              </span>
            </Tooltip>
            <Tooltip title="Logout" placement="right">
              <span>                
                <MenuItem
                  data-testid="signout-link"
                  component={<Link to="#" />}
                  suffix="Logout"
                  onClick={() => {
                    localStorage.clear();
                    // Clear the page content
                    document.body.innerHTML = "";

                    // Replace the current URL with a new one
                    window.history.replaceState(
                      null,
                      null,
                      window.location.href,
                    );
                  }}
                >
                  <img  
                      width={"24px"}
                      src="/images/Logout-1.png"
                      alt=""
                      aria-hidden="true"
                      style={{ marginRight: 6 }}
                    />
                </MenuItem>
              </span>
            </Tooltip>
          </div>
          <div>
            <MenuItem>
              <Typography className="version-text">
                Version : v2.0.3
              </Typography>
            </MenuItem>
          </div>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default Navigation;
